import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import s from "./styles.scss";

interface Props {
  title: string;
  isOpen: boolean;
  toggle: () => void;
  size?: string;
  style?: object;
}

class ModalFrame extends React.Component<Props, void> {
  render() {
    const { size, title, toggle, style, children, ...config } = this.props;

    return (
      <Modal
        size={size || "md"}
        backdrop="static"
        keyboard={false}
        {...config}
        toggle={toggle}
        contentClassName={s.modalBorder}
        className={size == "lg" ? s.large : ""}
      >
        {title && (
          <ModalHeader
            className={s.modalHeader}
            toggle={toggle}
            style={this.props.style || {}}
          >
            {title}
          </ModalHeader>
        )}
        <ModalBody className={s.modalPadding} style={this.props.style || {}}>
          {children}
        </ModalBody>
      </Modal>
    );
  }
}

export default withStyles(s)(ModalFrame);
